const $ = require('jquery');
const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
// const SingleStopInfo = require('../components/single-stop-info');
const Row = require('../components/row');
const datejs = require('datejs'); // not called directly but used for extended parsing ability


module.exports = {
  name: 'city-schedule',
  props: {
    allTrips: {
      type: Object,
      required: true,
    },
    allStops: {
      type: Object,
      required: true,
    },
    routeData: {
      type: Array,
      required: true,
    },
    currentCity: {
      type: String,
      required: true,
    },
    stopInfo: {
      type: Array,
      required: false,
    },
    onDrag: {
      type: Function,
      required: false,
    },
    scrolledX: {
      type: Number,
      required: false,
    },
    expanded: {
      type: Boolean,
      required: true,
    },
    cityName: {
      type: String,
      required: true,
    }
  },

  data: function() {
    return {
      shouldScroll: null,
    };
  },

  computed: {
    visibleStops() {
      // fitler stops to be shown based on timepoint, or all if expand bool is true
      if (this.expanded) {
        return this.allStops;
      }
      const tmpVisibleStops = {};
      for (const stop of Object.entries(this.allStops)) {
        const [id, data] = stop;
        if (data.timepoint === 'exact') {
          tmpVisibleStops[id] = data;
        }
      }

      return tmpVisibleStops;
    },
  },

  methods: {
    // sorts objects and keeps their key as first item in nested array
    // second parameter is what the object should be sorted by - must be a number for this function
    objectSorter(obj, itemToSortBy) {
      const sortedArray = [];
      for (const key in obj) {
        sortedArray.push([key, parseInt(obj[key][itemToSortBy])]);
      }
      sortedArray.sort((a, b) => {
        const seqA = parseInt(a[1]);
        const seqB = parseInt(b[1]);
        if (seqA < seqB) {
          return -1;
        }
        if (seqA > seqB) {
          return 1;
        }
        // sequence must be equal
        return 0;
      });
      // console.log(sortedArray);
      return sortedArray;
    },

    beforeEnter(el) {
      // console.log(el.clientHeight);
      el.dataset.height = el.clientHeight;
      el.style.height = '0px';
    },

    enter(el, done) {
      // console.log(el.clientHeight);
      el.style.height = `${el.dataset.height}px`;
      // must manually call done() since CSS isn't used for animations
      setTimeout(function () {
        done();
      }, 500);
    },

    afterEnter(el) {
      // after in and animated, remove the hard height so resizing doesn't cause issues
      el.style.removeProperty('height');
    },

    beforeLeave(el) {
      // right before leaving, reset height inline to animate properly
      el.style.height = `${el.clientHeight}px`;
    },

    leave(el, done) {
      // must call height zero on next animation frame to make sure beforeleave hook height is set
      requestAnimationFrame(() => {
        el.style.height = '0px';
        // must manually call done() since CSS isn't used for animations
        setTimeout(function () {
          done();
        }, 500);
      })


    },

  },

  render() {
    const sortedStops = this.objectSorter(this.visibleStops, 'sequence');
    const sortedTrips = this.objectSorter(this.allTrips, 'time');
    // console.log('sortedStops');
    // console.log(sortedStops);
    return (
      <div>
        {sortedStops.length > 0 &&
          <div>
          <h3 class="schedule__panel__city-title">
            {this.cityName}
          </h3>
          <div class="schedule__panel__table__wrapper">
            <transition-group
              name="list"
              onBeforeEnter={this.beforeEnter}
              onEnter={this.enter}
              onAfterEnter={this.afterEnter}
              onBeforeLeave={this.beforeLeave}
              onLeave={this.leave}
              duration="500"
              tag="div"
              css={false}
              class="table schedule__panel__table">

              {/* build rows first */}
              {sortedStops.map(stop =>
                <Row
                  stop={this.allStops[stop[0]]}
                  stopInfo={this.stopInfo}
                  allTrips={this.allTrips}
                  sortedTrips={sortedTrips}
                  routeData={this.routeData}
                  key={this.allStops[stop[0]].alias} />
              )}
              </transition-group>
            <div class="gradient"></div>
            </div>
          </div>
        }
      </div>
    );
  },
};
